import React from 'react';
import { PossibleImageSizes } from '@axiom/const';
import {
  CandidateProfileUtil,
  ImageCircle,
  Layout,
  LayoutItem,
  ModalHeader,
} from '@axiom/ui';

import type { InterviewFlowCandidate } from '../../types/interview-candidate.types';

export interface TalentInterviewModalHeaderProps {
  candidate: InterviewFlowCandidate;
  name: string;
  onClose: () => void;
}

export const TalentInterviewModalHeader = ({
  candidate,
  name,
  onClose,
}: TalentInterviewModalHeaderProps) => {
  return (
    <ModalHeader name={name} onClose={onClose}>
      <Layout position="middle" wrap>
        <LayoutItem rightGutter="16px">
          <ImageCircle
            imageName={candidate.calculatedDisplayName}
            src={CandidateProfileUtil.getProfileImageUri(
              candidate,
              PossibleImageSizes.W_100
            )}
            size="small"
            name={`${name}_TALENT_IMAGE`}
          />
        </LayoutItem>
        <LayoutItem fluid name={`${name}_TEXT`}>
          Interview{' '}
          {candidate.calculatedFirstName || candidate.calculatedDisplayName}
        </LayoutItem>
      </Layout>
    </ModalHeader>
  );
};
